var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlFlag = function SvgPlFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .plflag-cls-1 {\n        fill: #fff;\n      }\n\n      .plflag-cls-2 {\n        fill: #df0914;\n      }\n\n      .plflag-cls-3 {\n        fill: none;\n        stroke: #df0914;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "plflag-cls-1",
    x: 2,
    y: 2,
    width: 92.55,
    height: 61.62,
    rx: 10.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "plflag-cls-2",
    d: "M2.28,32.62h91a0,0,0,0,1,0,0V53.91a9.71,9.71,0,0,1-9.71,9.71H13.28a11,11,0,0,1-11-11v-20a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "plflag-cls-3",
    x: 2,
    y: 2,
    width: 92.55,
    height: 61.62,
    rx: 10.24
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PLFlag.0b45ec73.svg";
export { ForwardRef as ReactComponent };